import { Filter } from '@ami/react/core';

export class FreightCarrierFilter extends Filter {
  constructor(filter) {
    super();
    if (filter) {
      this.search = filter.search;
      this.includeRetired = filter.includeRetired;
      return this;
    }
    this.search = '';
    this.includeRetired = false;
  }
}
